"use client";

import { useEffect } from "react";

export function ReferralTracker() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("rc");
    if (!ref) return;

    // Clean the URL by removing everything after the rc parameter
    const cleanUrl = cleanUrlAfterReferralCode(url, ref);

    if (sessionStorage.getItem(`ref-logged-${ref}-${cleanUrl}`)) return;

    fetch("/api/log-referral", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        referral_code: ref,
        full_url: cleanUrl,
      }),
    });

    sessionStorage.setItem(`ref-logged-${ref}-${cleanUrl}`, "true");
  }, []);

  return null;
}

function cleanUrlAfterReferralCode(url, referralCode) {
  const params = new URLSearchParams();

  // Iterate through all parameters and only keep those that come before or are the rc parameter
  for (const [key, value] of url.searchParams.entries()) {
    params.append(key, value);

    // Stop adding parameters after we encounter the rc parameter
    if (key === "rc") {
      break;
    }
  }

  // Construct the clean URL
  const cleanUrl =
    url.pathname + (params.toString() ? `?${params.toString()}` : "");
  return cleanUrl;
}
